import { AccountView } from '@/types/entity-types';
import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';

const OPEN_BANKING_ADAPTERS = [
  FinancialServiceProviderAdapters.GOCARDLESS,
  FinancialServiceProviderAdapters.YAPILY,
  FinancialServiceProviderAdapters.STRIPE,
];

export const isOpenBankingAccount = (account: AccountView): boolean => {
  if (!account.fspAdapter) {
    return false;
  }

  return OPEN_BANKING_ADAPTERS.includes(account.fspAdapter);
};
